// Global Namespace
var cube = this.cube || {};

if (typeof window !== 'undefined') {
  window.cube = cube;
}

cube.error = function(obj, type) {
  type = type || Error;
  throw new type(obj);
};

cube.global = this;

// Tool function
(function(cube) {

  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  var slice            = ArrayProto.slice,
  unshift          = ArrayProto.unshift,
  toString         = ObjProto.toString,
  hasOwnProperty   = ObjProto.hasOwnProperty;

  // ECMAScript 5
  var
  nativeForEach      = ArrayProto.forEach,
  nativeMap          = ArrayProto.map,
  nativeReduce       = ArrayProto.reduce,
  nativeReduceRight  = ArrayProto.reduceRight,
  nativeFilter       = ArrayProto.filter,
  nativeEvery        = ArrayProto.every,
  nativeSome         = ArrayProto.some,
  nativeIndexOf      = ArrayProto.indexOf,
  nativeLastIndexOf  = ArrayProto.lastIndexOf,
  nativeIsArray      = Array.isArray,
  nativeKeys         = Object.keys,
  nativeCreate     = Object.create,
  nativeBind         = FuncProto.bind;

  // Array / Set
  // -----------------

  var breaker = {};

  // foreach
  cube.forEach = function(obj, iterator, context) {
    if (obj == null) {
      return;
    }
    if (nativeForEach && obj.forEach === nativeForEach) {
      obj.forEach(iterator, context);
    } else if (cube.isNumber(obj.length)) {
      for (var i = 0, l = obj.length; i < l; i++) {
        if (iterator.call(context, obj[i], i, obj) == breaker) {
          return;
        }
      }
    } else {
      for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          if (iterator.call(context, obj[key], key, obj) === breaker) {
            return;
          }
        }
      }
    }
  };

  // map the property, use the return value.
  cube.map = function(obj, iterator, context) {
    var results = [];
    if (obj == null) {
      return results;
    }
    if (nativeMap && obj.map === nativeMap) {
      return obj.map(iterator, context);
    }
    cube.forEach(obj, function(value, index, list) {
      results[results.length] = iterator.call(context, value, index, list);
    });
    return results;
  };

  // reduce
  cube.reduce = function(obj, iterator, memo, context) {
    var initial = memo !== void 0;
    if (obj == null) {
      obj = [];
    }
    if (nativeReduce && obj.reduce === nativeReduce) {
      if (context) {
        iterator = cube.bind(iterator, context);
      }
      return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
    }
    cube.forEach(obj, function(value, index, list) {
      if (!initial && index === 0) {
        memo = value;
        initial = true;
      } else {
        memo = iterator.call(context, memo, value, index, list);
      }
    });
    if (!initial) {
      throw new TypeError("Reduce of empty array with no initial value");
    }
    return memo;
  };

  // reduce reverse
  cube.reduceRight = function(obj, iterator, memo, context) {
    if (obj == null) {
      obj = [];
    }
    if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
      if (context) iterator = cube.bind(iterator, context);
      return memo !== void 0 ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
    }
    var reversed = (cube.isArray(obj) ? obj.slice() : cube.Array.toArray(obj)).reverse();
    return cube.reduce(reversed, iterator, memo, context);
  };

  // find the first one
  cube.detect = function(obj, iterator, context) {
    var result;
    cube.some(obj, function(value, index, list) {
      if (iterator.call(context, value, index, list)) {
        result = value;
        return true;
      }
    });
    return result;
  };

  cube.chunk = function(list, size) {
    if (!size || !list) {
      return list;
    }
    var result = [];
    while (list.length > 0)
      result.push(list.splice(0, size));
    return result;
  };

  // filter
  cube.filter = function(obj, iterator, context) {
    var results = [];
    if (obj == null) {
      return results;
    }
    if (nativeFilter && obj.filter === nativeFilter) {
      return obj.filter(iterator, context);
    }
    cube.forEach(obj, function(value, index, list) {
      if (iterator.call(context, value, index, list)) results[results.length] = value;
    });
    return results;
  };

  // check every
  cube.every = function(obj, iterator, context) {
    var result = true;
    if (obj == null) {
      return result;
    }
    if (nativeEvery && obj.every === nativeEvery) {
      return obj.every(iterator, context);
    }
    cube.forEach(obj, function(value, index, list) {
      if (!(result = result && iterator.call(context, value, index, list))) {
        return breaker;
      }
    });
    return result;
  };

  // has some
  cube.some = function(obj, iterator, context) {
    iterator || (iterator = cube.identity);
    var result = false;
    if (obj == null) {
      return result;
    }
    if (nativeSome && obj.some === nativeSome) {
      return obj.some(iterator, context);
    }
    cube.forEach(obj, function(value, index, list) {
      if (iterator.call(context, value, index, list)) {
        result = true;
        return breaker;
      }
    });
    return result;
  };

  // contains
  cube.contains = function(obj, target) {
    var found = false;
    if (obj == null) {
      return found;
    }
    if (nativeIndexOf && obj.indexOf === nativeIndexOf) {
      return obj.indexOf(target) != -1;
    }
    cube.some(obj, function(value) {
      if (found = value === target) {
        return true;
      }
    });
    return found;
  };

  // get fields
  cube.pluck = function(obj, key) {
    return cube.map(obj, function(value) {
      return value[key];
    });
  };

  // sort
  cube.sortBy = function(obj, iterator, context) {
    return cube.pluck(cube.map(obj, function(value, index, list) {
      return {
        value : value,
        criteria : iterator.call(context, value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria, b = right.criteria;
      return a < b ? -1 : a > b ? 1 : 0;
    }), 'value');
  };

  // Use a comparator function to figure out at what index an object should
  // be inserted so as to maintain order. Uses binary search.
  cube.sortedIndex = function(array, obj, iterator) {
    iterator || (iterator = cube.identity);
    var low = 0, high = array.length;
    while (low < high) {
      var mid = (low + high) >> 1;
      iterator(array[mid]) < iterator(obj) ? low = mid + 1 : high = mid;
    }
    return low;
  };

  // toArray
  cube.toArray = function(iterable) {
    if (!iterable)                return [];
    if (iterable.toArray)         return iterable.toArray();
    if (cube.isArray(iterable))      return iterable;
    if (cube.isArguments(iterable))  return slice.call(iterable);
    return cube.values(iterable);
  };

  // Array
  // ---------------

  // last
  cube.last = function(array) {
    var len = array.length;
    return len > 0 ? array[ len - 1 ] : undefined;
  };

  // return which is true
  cube.compact = function(array) {
    return cube.filter(array, function(value) {
      return !!value;
    });
  };

  // flatten
  cube.flatten = function(array) {
    return cube.reduce(array, function(memo, value) {
      if (cube.isArray(value)) {
        return memo.concat(cube.flatten(value));
      }
      memo[memo.length] = value;
      return memo;
    }, []);
  };

  // remove
  cube.without = function(array, obj) {
    var values = slice.call(arguments, 1);
    return cube.filter(array, function(value) {
      return !cube.contains(values, value);
    });
  };

  // unique
  cube.unique = function(array, isSorted) {
    return cube.reduce(array, function(memo, el, i) {
      if (0 == i || (isSorted === true ? cube.last(memo) != el : !cube.contains(memo, el))) memo[memo.length] = el;
      return memo;
    }, []);
  };

  // intersect
  cube.intersect = function(array) {
    var rest = slice.call(arguments, 1);
    return cube.filter(cube.unique(array), function(item) {
      return cube.every(rest, function(other) {
        return cube.indexOf(other, item) >= 0;
      });
    });
  };

  // indexOf
  cube.indexOf = function(array, item, isSorted) {
    if (array == null) return -1;
    var i, l;
    if (isSorted) {
      i = cube.sortedIndex(array, item);
      return array[i] === item ? i : -1;
    }
    if (nativeIndexOf && array.indexOf === nativeIndexOf) {
      return array.indexOf(item);
    }
    for (i = 0, l = array.length; i < l; i++) if (array[i] === item) {
      return i;
    }
    return -1;
  };

  // lastIndexOf
  cube.lastIndexOf = function(array, item) {
    if (array == null) return -1;
    if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
      return array.lastIndexOf(item);
    }
    var i = array.length;
    while (i--) if (array[i] === item) {
      return i;
    }
    return -1;
  };

  // Function
  // ------------------

  // bind
  cube.bind = function(func, context) {
    var extraArgs = Array.prototype.slice.call(arguments, 2);
    return function() {
      context = context || (this == cube.global ? false : this);
      var args = extraArgs.concat(Array.prototype.slice.call(arguments));
      if (typeof(func) == "string" && context[func]) {
        context[func].apply(context, args);
      } else if (cube.isFunction(func)) {
        return func.apply(context, args);
      } else {
      }
    };
  };

  // methodize, the first will be: this, or this[attr]
  cube.methodize = function(func, attr) {
    if (attr) {
      return function() {
        return func.apply(null, [this[attr]].concat([].slice.call(arguments)));
      };
    }
    return function() {
      return func.apply(null, [this].concat([].slice.call(arguments)));
    };
  };

  cube.extend = function(klass, proto) {

    var T = function() {}; // build prototype-chain
    T.prototype = proto.prototype;

    var klassProto = klass.prototype;

    klass.prototype = new T();

    // coyp the methods if the prototype has some
    cube.mix(klass.prototype, klassProto, true);

    cube.mix(klass, proto);
    klass.$super = proto; // use arguments.callee.$super to call parent construct.

    return klass;
  };

  // create a new Object base on given Object.prototype
  cube.create = nativeCreate || function(proto, props) {
    var ctor = function(ps) {
      if (ps) {
        cube.mix(this, ps);
      }
    };
    ctor.prototype = proto;
    return new ctor(props);
  };

  // delay
  cube.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function() {
      return func.apply(func, args);
    }, wait);
  };

  cube.defer = function(func) {
    return cube.delay.apply(cube, [func, 1].concat(slice.call(arguments, 1)));
  };

  // Object
  // ----------------

  // list all keys
  cube.keys = nativeKeys || function(obj) {
    if (obj !== Object(obj)) {
      throw new TypeError('Invalid object');
    }
    var keys = [];
    for (var key in obj) if (hasOwnProperty.call(obj, key)) {
      keys[keys.length] = key;
    }
    return keys;
  };

  // list all values
  cube.values = function(obj) {
    return cube.map(obj, cube.identity);
  };

  // list all functions
  cube.methods = function(obj) {
    return cube.filter(cube.keys(obj), function(key) {
      return cube.isFunction(obj[key]);
    }).sort();
  };

  // merge properties in to obj
  cube.mix = function(obj) {
    cube.forEach(slice.call(arguments, 1), function(source) {
      for (var prop in source) if (source[prop] !== void 0) {
        obj[prop] = source[prop];
      }
    });
    return obj;
  };

  // clone
  cube.clone = function(obj) {
    return cube.isArray(obj) ? obj.slice() : cube.mix({}, obj);
  };

  // empty object or Array
  cube.isEmpty = function(obj) {
    if (cube.isArray(obj) || cube.isString(obj)) {
      return obj.length === 0;
    }
    for (var key in obj) if (hasOwnProperty.call(obj, key)) {
      return false;
    }
    return true;
  };

  // check if it is a html element
  cube.isElement = function(obj) {
    return !!(obj && obj.nodeType == 1);
  };

  cube.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // check if it is function
  cube.isFunction = function(obj) {
    return !!(obj && obj.constructor && obj.call && obj.apply);
  };

  if (toString.call(arguments) == '[object Arguments]') {
    cube.isArguments = function(obj) {
      return toString.call(obj) == '[object Arguments]';
    };
  } else {
    cube.isArguments = function(obj) {
      return !!(obj && hasOwnProperty.call(obj, 'callee'));
    };
  }

  cube.isString = function(obj) {
    return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
  };

  cube.isNumber = function(obj) {
    return !!(obj === 0 || (obj && obj.toExponential && obj.toFixed));
  };

  cube.isNaN = function(obj) {
    return obj !== obj;
  };

  cube.isBoolean = function(obj) {
    return obj === true || obj === false;
  };

  cube.isDate = function(obj) {
    return !!(obj && obj.getTimezoneOffset && obj.setUTCFullYear);
  };

  cube.isRegExp = function(obj) {
    return !!(obj && obj.test && obj.exec && (obj.ignoreCase || obj.ignoreCase === false));
  };

  cube.isNull = function(obj) {
    return obj === null;
  };

  cube.isUndefined = function(obj) {
    return obj === void 0;
  };

  // String functions
  // -----------------

  cube.trim = function(str) {
    return str.replace(/^[\s\xa0\u3000]+|[\u3000\xa0\s]+$/g, "");
  };

  // return the byte length
  cube.byteLen = function(str) {
    return str.replace(/[^\x00-\xff]/g, "--").length;
  };

  // sub by byte length
  cube.subByte = function(str, len, tail) {
    if (cube.byteLen(str) <= len) {
      return str;
    }
    tail = tail || '';
    len -= cube.byteLen(tail);
    return str.substr(0, len).replace(/([^\x00-\xff])/g, "$1 ") //双字节字符替换成两个
    .substr(0, len) // 截取长度
    .replace(/[^\x00-\xff]$/, "") //去掉临界双字节字符
    .replace(/([^\x00-\xff]) /g, "$1") + tail; //还原
  };

  // encode for JS
  cube.encode4JS = function(str) {
    return str.replace(/\\/g, "\\u005C")
    .replace(/"/g, "\\u0022")
    .replace(/'/g, "\\u0027")
    .replace(/\//g, "\\u002F")
      .replace(/\r/g, "\\u000A")
    .replace(/\n/g, "\\u000D")
    .replace(/\t/g, "\\u0009");
  };

  // encode invisiable, unsecure, reserve chars
  cube.encode4HTTP = function(str) {
    return str.replace(/[\u0000-\u0020\u0080-\u00ff\s"'#\/\|\\%<>\[\]\{\}\^~;\?\:@=&]/, function(s) {
      return encodeURIComponent(s);
    });
  };

  /**
  *
  * @method encode4Html
  * @static
  * @param {String} s
  * @return {String}
  * @example
  var s="<div>dd";
  alert(encode4Html(s));
  */
  cube.encode4Html = function(s){
    return s.replace(/&(?!\w+;|#\d+;|#x[\da-f]+;)/gi, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/\//g,'&#x2F;');
  };

    /**
    * @method encode4HtmlValue
    * @static
    * @param {String} s the string
    * @return {String} the string after processed
    * @example:
    var s="<div>\"\'ddd";
    alert("<input value='"+encode4HtmlValue(s)+"'>");
    */
    cube.encode4HtmlValue = function(s){
      return cube.encode4Html(s).replace(/"/g,"&quot;").replace(/'/g,"&#039;");
    }

    // remove all <tag>，and </tag>
    cube.stripTags = function(str) {
      return str.replace(/<[^>]*>/gi, '');
    };

    // date format
    //------------------
    /**
    * y, M, d, h, m, s
    * @method format
    * @static
    * @param {Date} d Date
    * @param {string} pattern y, M, d, h, m, s. the default is "yyyy-MM-dd"
    * @return {string}  the string after format
    * @example
    */
    cube.formatDate = function(d, pattern){
      pattern=pattern||"yyyy-MM-dd";
      var y = d.getFullYear();
      var o = {
        "M" : d.getMonth()+1, //month
        "d" : d.getDate(),    //day
        "h" : d.getHours(),   //hour
        "m" : d.getMinutes(), //minute
        "s" : d.getSeconds() //second
      }
      pattern = pattern.replace(/(y+)/ig, function(a,b){
        var len = Math.min(4,b.length);
        return (y + "").substr(4 - len);
      });
      for (var i in o) {
        pattern = pattern.replace(new RegExp("("+i+"+)","g"), function(a, b){
          return (o[i]<10 && b.length>1) ? "0"+ o[i] : o[i];
        });
      }
      return pattern;
    }

    // identity, just return value
    // -----------------

    cube.identity = function(value) {
      return value;
    };

    // uniqueId
    var idCounter = 0;
    cube.uniqueId = function(prefix) {
      var id = idCounter++;
      return prefix ? prefix + id : id;
    };

})(cube);

/**
* data
*/
(function(cube) {
  var dataList = {};

  cube.data = {

    set: function() {
      if (arguments.length == 2) {
        dataList[arguments[0]] = argments[1];
      } else {
        dataList = arguments[0];
      }
    },

    get: function(key) {
      if (key) {
        return dataList[key];
      }
      return dataList;
    },
  };
}(cube));

module.exports = cube;

cube.Array = {
  toArray: cube.toArray,
  chunk: cube.chunk
}
require('./cube-event.js');
require('./cube-cust-event.js');



//////////////////
// WEBPACK FOOTER
// ./src/js/~/cube.js
// module id = 35
// module chunks = 1